// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AccountingQueries } from '../../../../types/server/modules/accounting/queries';

export type * from '../../../../types/server/modules/accounting/queries';

export const createQueries = ( requests: Requests ): AccountingQueries => ({
  AccountingAccountsById: ( id, query, headers ) => { 
          return requests.get( `/accounting/accounts/${id}`, query, headers ); 
        },
  AccountingAccounts: ( params?, headers? ) => {
        return requests.get( `/accounting/accounts/:id?`, params, headers );
      },
  FiscalPeriodReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/fiscal-period-readmodel/${id}`, query, headers ); 
        },
  FiscalPeriodReadmodel: ( params?, headers? ) => {
        return requests.get( `/fiscal-period-readmodel/:id?`, params, headers );
      },
  LedgerByAccountReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/ledger-by-account-readmodel/${id}`, query, headers ); 
        },
  LedgerByAccountReadmodel: ( params?, headers? ) => {
        return requests.get( `/ledger-by-account-readmodel/:id?`, params, headers );
      },
  TrialBalanceReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/trial-balance-readmodel/${id}`, query, headers ); 
        },
  TrialBalanceReadmodel: ( params?, headers? ) => {
        return requests.get( `/trial-balance-readmodel/:id?`, params, headers );
      },
  JournalEntryListReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/journal-entry-list-readmodel/${id}`, query, headers ); 
        },
  JournalEntryListReadmodel: ( params?, headers? ) => {
        return requests.get( `/journal-entry-list-readmodel/:id?`, params, headers );
      }
});
